import pino from "pino";

export default pino({
  // usual pino config
  level: process.env.LOGGER_LEVEL ?? "error",
  browser: {
    asObject: true,
    write: (o) => {
      console.log(o);
    },
  },
});
